import "@/assets/css/reset.css"
import "@/assets/css/general.css"
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VuePapaParse from 'vue-papa-parse'

import { createI18n } from 'vue-i18n'
import zh from "./i18n/zh-TW.json";
import en from "./i18n/en-US.json";

const i18n = createI18n({
   locale: "zh", //預設語言
   fallbackLocale: "zh-TW",
   messages: { 
    "zh-TW": zh, 
    "en": en 
    },
});



import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

library.add(fas)
library.add(far)

// createApp(App).use(router).mount('#app')
createApp(App).use(i18n).use(router).use(VuePapaParse).component('font-awesome-icon', FontAwesomeIcon).mount('#app')